export default __webpack_public_path__ + "static/media/empty_categories.9873b58b.png";